const config = {
	baseApiUrl: 'https://externalapps.metrostlouis.org/vrpform/api',
	reCaptchaSiteKey: '6LfDSnsUAAAAALSCF0jw64EBNVefrEaXXVJvE9bv'
};

export default config;
